import React, { useEffect, useState } from 'react';
import { Trash2, MailOpen, Mail, Phone } from 'lucide-react';
import api from '../../lib/api';

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [selected, setSelected] = useState(null);
  const load = () => api.get('/admin/contact').then((r) => setMessages(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (m) => { await api.post(`/admin/contact/${m.id}/read`); load(); if (selected?.id === m.id) setSelected({ ...m, read: true }); };
  const del = async (m) => { if (!window.confirm('Delete this message?')) return; await api.delete(`/admin/contact/${m.id}`); setSelected(null); load(); };

  return (
    <div>
      <h1 className="font-heading font-bold text-3xl text-[#0F1C2E] mb-6">Contact Messages</h1>
      <div className="grid lg:grid-cols-[380px_1fr] gap-6">
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden max-h-[70vh] overflow-y-auto">
          {messages.length === 0 ? (
            <div className="p-8 text-center text-gray-400 text-sm">No messages yet</div>
          ) : messages.map((m) => (
            <button key={m.id} onClick={() => { setSelected(m); if (!m.read) markRead(m); }} className={`w-full text-left px-5 py-4 border-b border-gray-50 hover:bg-[#FDF3EC] transition ${selected?.id === m.id ? 'bg-[#FDF3EC]' : ''}`}>
              <div className="flex items-center gap-2 mb-1">
                {m.read ? <MailOpen size={14} className="text-gray-400" /> : <Mail size={14} className="text-[#ED2E2E]" />}
                <span className={`font-semibold text-sm ${m.read ? 'text-gray-600' : 'text-[#0F1C2E]'}`}>{m.firstName} {m.lastName}</span>
              </div>
              <div className="text-xs text-gray-500 truncate">{m.message}</div>
              <div className="text-xs text-gray-400 mt-1">{new Date(m.created_at).toLocaleString()}</div>
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-8">
          {!selected ? (
            <div className="text-center text-gray-400 py-16">Select a message to view</div>
          ) : (
            <div>
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h2 className="font-heading font-bold text-2xl text-[#0F1C2E]">{selected.firstName} {selected.lastName}</h2>
                  <div className="text-sm text-gray-500 mt-1">{new Date(selected.created_at).toLocaleString()}</div>
                </div>
                <button onClick={() => del(selected)} className="p-2 hover:bg-red-50 text-gray-400 hover:text-red-500 rounded-lg"><Trash2 size={18} /></button>
              </div>
              <div className="space-y-2 mb-6 text-sm">
                <div className="flex items-center gap-2 text-gray-700"><Mail size={14} /> <a href={`mailto:${selected.email}`} className="text-[#ED2E2E]">{selected.email}</a></div>
                <div className="flex items-center gap-2 text-gray-700"><Phone size={14} /> <a href={`tel:${selected.phone}`} className="text-[#ED2E2E]">{selected.phone}</a></div>
              </div>
              <div className="bg-[#FDF3EC] rounded-2xl p-6">
                <p className="whitespace-pre-wrap text-gray-800">{selected.message}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
